<div class="white-box">
  <div class="content">

    <div class="section-title">
      <div>{{'proposalDetails.createOfferTab.yourDataSection.yourData'|translate}}</div>
    </div>

    <ng-container *ngIf="(user$|async) as user">

      <b>{{'proposalDetails.createOfferTab.yourDataSection.brokerInformation' | translate}}</b>
      <div class="d-flex flex-column">
        <div class="d-flex proposal-details-row">
          <div class="info-col">{{'proposalDetails.createOfferTab.yourDataSection.insuranceCompanyName'|translate}}:
          </div>
          <div>{{user.company.name}}</div>
        </div>
        <div class="d-flex proposal-details-row">
          <div class="info-col">{{'proposalDetails.createOfferTab.yourDataSection.street'|translate}},
            {{'proposalDetails.createOfferTab.yourDataSection.houseNumber'|translate}}:
          </div>
          <div>{{user.company.street}} {{user.company.houseNumber}}</div>
        </div>
        <div class="d-flex proposal-details-row">
          <div class="info-col">{{'proposalDetails.createOfferTab.yourDataSection.postalCode'|translate}},
            {{'proposalDetails.createOfferTab.yourDataSection.location'|translate}}:
          </div>
          <div>{{user.company.postalCode}} {{user.company.location}}</div>
        </div>
        <div class="d-flex proposal-details-row">
          <div class="info-col">{{'proposalDetails.createOfferTab.yourDataSection.countryCode'|translate}}, {{'proposalDetails.createOfferTab.yourDataSection.country'|translate}}:</div>
          <div>{{user.company.countryCode}}, {{'countryCodes.' + user.company.countryCode | translate}}</div>
        </div>
      </div>
      <hr class="line" >

      <b>{{'proposalDetails.createOfferTab.yourDataSection.contactPerson'|translate}}:</b>
      <div class="d-flex flex-column">
        <div class="d-flex proposal-details-row">
          <div class="info-col">{{'proposalDetails.createOfferTab.yourDataSection.firstName'|translate}}:</div>
          <div>{{user.firstName}}</div>
        </div>
        <div class="d-flex proposal-details-row">
          <div class="info-col">{{'proposalDetails.createOfferTab.yourDataSection.lastName'|translate}}:</div>
          <div>{{user.lastName}}</div>

        </div>
        <div class="d-flex proposal-details-row">
          <div class="info-col">{{'proposalDetails.createOfferTab.yourDataSection.phoneNumber'|translate}}:</div>
          <div>{{user.telephoneNumber}}</div>

        </div>
        <div class="d-flex proposal-details-row">
          <div class="info-col">{{'proposalDetails.createOfferTab.yourDataSection.mobileNumber'|translate}}:</div>
          <div>{{user.mobileNumber}}</div>

        </div>
        <div class="d-flex proposal-details-row">
          <div class="info-col">{{'proposalDetails.createOfferTab.yourDataSection.emailAddress'|translate}}:</div>
          <div>{{user.email}}</div>
        </div>
      </div>
    </ng-container>
  </div>

</div>
